import { FC } from 'react';
import { useFieldState, useFormApi } from 'informed';
import { t } from 'i18next';
import moment from 'moment';
import { DateField } from '@ui-modules/informed';
import '../../BookingPanel.styles.scss';

interface PickupDateFieldProps {
  disabled?: boolean;
  leg: number;
  value: string;
  onChange?: (value: Date | string) => void;
}

const PickupDateField: FC<PickupDateFieldProps> = ({ disabled, leg, value, onChange }) => {
  const formApi = useFormApi();
  const { value: dropoffDate } = useFieldState(`${leg}.dropoffDate`);

  return (
    <div className="field">
      <DateField
        className="input"
        defaultValue={moment(value, 'YYYY-MM-DD').toDate()}
        disabled={disabled}
        dropdownMode="select"
        label={t('bookingDetails.pickupDate')}
        name={`${leg}.pickupDate`}
        showMonthDropdown
        showYearDropdown
        onChange={(val: Date | string) => {
          onChange?.(val);
          if (moment(val).isAfter(dropoffDate as Date)) {
            formApi.setValue(`${leg}.dropoffDate`, val);
          }
        }}
      />
    </div>
  );
};

export default PickupDateField;
